export const conversation = "qzc";
export const conversations = "rzc";
export const item = "szc";
export const items = "tzc";
export default {conversation,conversations,item,items};